import React from 'react';
import { Testimonial } from '../types';
import { Card } from './Card';

interface TestimonialCardProps {
  testimonial: Testimonial;
}

export const TestimonialCard: React.FC<TestimonialCardProps> = ({ testimonial }) => {
  return (
    <Card className="p-6 shadow-lg border border-gray-200">
      <div className="flex flex-col">
        <div className="text-4xl text-primary-600 mb-2">"</div>
        <p className="text-gray-700 italic mb-4">{testimonial.text}</p>
        <div className="flex items-center mt-auto">
          <div className="w-10 h-10 bg-primary-100 rounded-full flex items-center justify-center mr-3">
            <span className="text-primary-600 font-bold">{testimonial.author[0]}</span>
          </div>
          <div>
            <div className="font-semibold text-gray-800">{testimonial.author}</div>
            <div className="text-sm text-gray-500">Verified Customer</div>
          </div>
        </div>
      </div>
    </Card>
  );
};
